<div style="font-size:13px; font-family:Roboto, Arial, sans-serif;">
	<div>
		<h5><strong><%= name %></strong></h5>
		<strong><%= company_name %><br /><%= company_tax_number %></strong>
	</div>

	<hr class="my-2" style="opacity:0.15;" />

	<table class="w-100 table-align-top mb-2" style="min-width:300px;">
		<tr>
			<td style="width:30%;"><strong>Hely címe</strong></td>
			<td><%= full_address %></td>
		</tr>
		<tr>
			<td><strong>Székhely</strong></td>
			<td><%= company_full_address %></td>
		</tr>
		<tr>
			<td><strong>Terminálok</strong></td>
			<td><%= terminal_count %></td>
		</tr>
		<tr style="color:darkcyan;">
			<td><strong>Adatbázis</strong></td>
			<td><%= company_db_name %></td>
		</tr>
	</table>

	<hr class="my-2" style="opacity:0.15;" />

	<ul class="treeview mb-2">
	<% for (const storage of storages) { %>
		<li><i class="fa fa-xs fa-warehouse me-1" style="color:dodgerblue; padding-left:2px;"></i><%= storage.name %><br />
			<ul>
			<% for (const terminal of storage.terminals) { %>
				<li>
					<i class="fa fa-xs fa-desktop me-1" style="color:dodgerblue; padding-left:2px;"></i><%= terminal.device_info.hostname || terminal.name %> <span class="float-end"><strong style="color:goldenrod;"><%= Anvil.numeral(terminal.licence_fee).format('0,0') %> Ft/hó</strong></span>
					<ul>
					<% if (terminal.ecr_info) { %>
						<% if (terminal.version != 'c-Store' && terminal.version != 'haccp' && Anvil.versions.compare(terminal.version, '2.2.12', '>=')) { %>
							<% if (terminal.ecr_info.type == 'ms-freepos') { %>
							<li><i class="fa fa-xs fa-receipt me-1" style="color:dodgerblue; padding-left:2px;"></i>MS-FreePOS</li>
							<% } else { %>
							<li><i class="fa fa-xs fa-cash-register me-1" style="color:dodgerblue; padding-left:2px;"></i>Sam4s</li>
							<% } %>
						<% } else { %>
							<% if (terminal.ecr_info.aee) for (const aee of terminal.ecr_info.aee) { %>
								<li><i class="fa fa-xs fa-receipt me-1" style="color:dodgerblue; padding-left:2px;"></i>MS-FreePOS</li>
							<% } %>
							<% if (terminal.ecr_info.sam4s) for (const sam4s of terminal.ecr_info.sam4s) { %>
								<li><i class="fa fa-xs fa-cash-register me-1" style="color:dodgerblue; padding-left:2px;"></i>Sam4s</li>
							<% } %>
						<% } %>
					<% } %>
					</ul>
				</li>
			<% } %>
			</ul>
		</li>
	<% } %>
	</ul>

	<button class="btn btn-sm btn-dark float-end" onclick="Anvil.page.openSite(<%- company_db_id %>, <%- id %>);"><i class="fa fa-fw fa-search me-1"></i>Részletek</button>
	<div class="mt-3">
		<small style="color:#999;"><i class="fa fa-map-pin me-1"></i> <%= Anvil.numeral(geo_coords[0]).format('0.00000').replace(',', '.') %>, <%= Anvil.numeral(geo_coords[1]).format('0.00000').replace(',', '.') %></small>
	</div>
</div>
